//declare var require: any;

import { stringify } from 'querystring';

import { DialogConfig } from '../models/DialogConfig';

export interface IAuthProvider {
    authorizeRequestInterceptor(config: any): any;
    authorizeResponseInterceptor(response: any): any;
    requestInterceptor(config: any): any;
    signalRRequestInterceptor(config: any): any;
    signalRNegotiateUrlBuilder(baseUrl: string): string;
    getToken(): string;
    lastLogin: Date;
}

import { v4 } from 'uuid';

const CryptoJS = require('crypto-js');

export class DialogAuthProvider implements IAuthProvider
{
    private _config: DialogConfig;
    private _token: string;
    private _expires: Date;
    private _id: string;

    public lastLogin: Date;

    public constructor(config: DialogConfig) {
        this._config = config;
        this._token = '';
        this._expires = new Date();
        this._id = '';
    }

    public authorizeRequestInterceptor(config: any): any {
        config.data = this._config.Claim;
        config.headers.Authorization = this._generateAuthorizationHeader(config);
        return config;
    }

    public authorizeResponseInterceptor(response: any): any {
        if(response.status === 200) {
            this._id = response.data.id;
            this._token = response.data.token;
            this._expires = new Date(response.data.expires);
            this.lastLogin = response.data.updatedOn ? new Date(response.data.updatedOn) : new Date();
        }
        return response;
    }

    public requestInterceptor(config: any): any {
        config.headers.axx = this._token;
        config.headers.Authorization = this._generateAuthorizationHeader(config);
        return config;
    }

    public signalRRequestInterceptor(config: any): any {
        config.params.axx = this._token;
        config.params.connectionToken = this._generateAuthorizationHeader(config);
        return config;
    }

    public getToken(): string {
        return this._token;
    }

    public signalRNegotiateUrlBuilder(baseUrl: string): string {
        return baseUrl + '?' + stringify({ axx: this._token });
    }

    private _generateAuthorizationHeader(config: any) {
        let nonce = v4();
        var timestamp = Date.now();            
        var requestUri = (config.url.substr(0, 1) == "/" ?
            config.baseUrl + config.url :
            config.url);
        var signature = this._config.AppKey +
            config.method.toLowerCase() +
            encodeURIComponent(requestUri).toLowerCase() +
            timestamp +
            nonce +
            (config.data ? CryptoJS.enc.Base64.stringify(CryptoJS.MD5(JSON.stringify(config.data))): '');
        var hashInBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(signature, this._config.AppSecret));
        return "amx " + this._config.AppKey + ":" + hashInBase64 + ":" + nonce + ":" + timestamp + ":" + (this._token || "");
    }
}